var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_522_9092)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_522_9092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1998 40H11.7998C9.14879 40 6.99976 37.851 6.99976 35.2V4.8C6.99976 2.14903 9.14879 0 11.7998 0H20.1526C21.598 0 22.9665 0.651346 23.8779 1.77315L31.9251 11.6774C32.6203 12.533 32.9998 13.6018 32.9998 14.7042V35.2C32.9998 37.851 30.8507 40 28.1998 40Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1998 39.4H11.7998C9.48016 39.4 7.59976 37.5196 7.59976 35.2V4.8C7.59976 2.4804 9.48016 0.6 11.7998 0.6H20.1526C21.4173 0.6 22.6147 1.16993 23.4123 2.15151L31.4594 12.0557C32.0677 12.8044 32.3998 13.7396 32.3998 14.7042V35.2C32.3998 37.5196 30.5194 39.4 28.1998 39.4Z",
    stroke: "#CDD0D5",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26 1V7.8C26 9.56731 27.4327 11 29.2 11H36",
    stroke: "#CDD0D5",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_522_9092)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_522_9092",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25C0 23.3431 1.34315 22 3 22H21C22.6569 22 24 23.3431 24 25V33C24 34.6569 22.6569 36 21 36H3C1.34315 36 0 34.6569 0 33V25Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 25C0 23.3431 1.34315 22 3 22H21C22.6569 22 24 23.3431 24 25V33C24 34.6569 22.6569 36 21 36H3C1.34315 36 0 34.6569 0 33V25Z",
    fill: "#DF1C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.8 25C-0.8 22.9013 0.901318 21.2 3 21.2H21C23.0987 21.2 24.8 22.9013 24.8 25H23.2C23.2 23.785 22.215 22.8 21 22.8H3C1.78497 22.8 0.8 23.785 0.8 25H-0.8ZM24 36H0H24ZM3 36C0.901318 36 -0.8 34.2987 -0.8 32.2V25C-0.8 22.9013 0.901318 21.2 3 21.2V22.8C1.78497 22.8 0.8 23.785 0.8 25V33C0.8 34.6569 1.78497 36 3 36ZM21 21.2C23.0987 21.2 24.8 22.9013 24.8 25V32.2C24.8 34.2987 23.0987 36 21 36C22.215 36 23.2 34.6569 23.2 33V25C23.2 23.785 22.215 22.8 21 22.8V21.2Z",
    fill: "black",
    fillOpacity: 0.08,
    mask: "url(#path-4-inside-1_522_9092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.63125 32V25.6H6.03125C6.52292 25.6 6.93542 25.6917 7.26875 25.875C7.60417 26.0583 7.85729 26.3104 8.02813 26.6312C8.20104 26.95 8.2875 27.3125 8.2875 27.7187C8.2875 28.1292 8.20104 28.4937 8.02813 28.8125C7.85521 29.1312 7.6 29.3823 7.2625 29.5656C6.925 29.7469 6.50938 29.8375 6.01563 29.8375H4.425V28.8844H5.85938C6.14688 28.8844 6.38229 28.8344 6.56563 28.7344C6.74896 28.6344 6.88438 28.4969 6.97188 28.3219C7.06146 28.1469 7.10625 27.9458 7.10625 27.7187C7.10625 27.4917 7.06146 27.2917 6.97188 27.1187C6.88438 26.9458 6.74792 26.8115 6.5625 26.7156C6.37917 26.6177 6.14271 26.5687 5.85313 26.5687H4.79063V32H3.63125ZM11.6393 32H9.47053V25.6H11.683C12.3184 25.6 12.8643 25.7281 13.3205 25.9844C13.7789 26.2385 14.1309 26.6042 14.3768 27.0812C14.6226 27.5583 14.7455 28.1292 14.7455 28.7937C14.7455 29.4604 14.6216 30.0333 14.3737 30.5125C14.1278 30.9917 13.7726 31.3594 13.308 31.6156C12.8455 31.8719 12.2893 32 11.6393 32ZM10.6299 30.9969H11.583C12.0289 30.9969 12.4007 30.9156 12.6987 30.7531C12.9966 30.5885 13.2205 30.3437 13.3705 30.0187C13.5205 29.6917 13.5955 29.2833 13.5955 28.7937C13.5955 28.3042 13.5205 27.8979 13.3705 27.575C13.2205 27.25 12.9987 27.0073 12.7049 26.8469C12.4132 26.6844 12.0507 26.6031 11.6174 26.6031H10.6299V30.9969ZM16.0231 32V25.6H20.1231V26.5719H17.1825V28.3094H19.8418V29.2812H17.1825V32H16.0231Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_522_9092",
    x: 5.39976,
    y: -3.2,
    width: 29.2,
    height: 45.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.894118 0 0 0 0 0.898039 0 0 0 0 0.905882 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_522_9092"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_522_9092",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.813571 0 0 0 0 0.82 0 0 0 0 0.826429 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_522_9092"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_522_9092",
    x: 0,
    y: 22,
    width: 24,
    height: 17.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_522_9092"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_522_9092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcons);
export default __webpack_public_path__ + "static/media/pdfIcons.9734c544bb2ec5e568da1e36547cab6a.svg";
export { ForwardRef as ReactComponent };